module.exports = __webpack_public_path__ + "pc/img/img_award2023_06.ccb26738.png";